<div style="width: 400px;border-radius: 15px;" *ngIf="!verified">
<div class="header">
  Account Verification
</div>

      <div style="padding: 20px 20px;">
      <p class="p-tag">
        You will be charged ₹4 for attempting beneficiary account verification. ₹1 will be credited to the beneficiary account in case of successful verification. Click Verify Account to proceed.
      </p>
    </div>
    
            <div class="row acbtn">
              <div class="col-md-6 cancel-btn" (click)='cancel()'><label>Cancel</label> </div>
              <div class="col-md-6 verify-btn" (click)='proceed()'><label>Verify Account</label></div>

               
            </div>
       
        
</div>

<div style="width: 400px;border-radius: 15px;" *ngIf="verified">
  <div class="header2">
   <img [src]="ymLogoPng" style="width: 60px;margin-top: 10px;"><br>
   <p>
    Beneficiary Account Verification Status
   </p>
  </div>
  
      
              <div class="row acbtn" style="border-bottom: 1px dashed black;">
                <div class="col-md-6" style="text-align: left;" >
                  <label>A/C No.</label><br> 
                  <label>IFSC</label> <br>
                  <label>Beneficiary</label> <br>

                </div>
                <div class="col-md-6" style="text-align: right;">
                  <label>{{getData.account_no}}</label><br>
                  <label>{{getData.ifc_code}}</label><br>
                  <label style="text-transform: uppercase;">{{getData.beneficiary_name}}</label><br>

                </div>
  
                 
              </div>
              <div>
                <span class="status">Status:</span><label class="status-data">{{getData.beneficiary_name}}(Beneficiary Successfully Verified by Bank)</label>
              </div>
              <div class="row acbtn">
                <div class="col-md-12 verify-btn" style="padding: 10px;" (click)='cancel()'>Close</div>
              </div>
         
          
  </div>